import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
//import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import {ContactComponent} from './home/contact.component'
import {AboutComponent} from './home/about.component'


const routes: Routes =[
    { path: 'home',             component: HomeComponent },
    //{ path: 'user-profile',     component: ProfileComponent },
    { path: 'signup',           component: SignupComponent },
    {path:'contact', component:ContactComponent},
    {path:'about', component:AboutComponent},
    
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {path:'products', loadChildren:'app/products/products.module#ProductsModule'},
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/app.routing.ts